/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useElementDimensions } from '@whitbread-eos/utils';
import { cn } from '@whitbread-eos/utils/server';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
export default function Main({ children, hasSidebar = true, collapsedSidebar = false, className }) {
    const pathname = usePathname();
    const [hasLevel2Navigation, setHasLevel2Navigation] = useState(pathname.includes('manage'));
    const { width: sidebarWidth } = useElementDimensions('[data-testid="SidebarDesktop-container"]');
    useEffect(()=>{
        setHasLevel2Navigation(pathname.includes('manage'));
    }, [
        pathname
    ]);
    let sidebarStyle = undefined;
    if (hasSidebar) {
        let widthStyle = hasLevel2Navigation ? sidebarLevel2Style : sidebarLevel1Style;
        if (collapsedSidebar) {
            widthStyle = sidebarCollapsedStyle;
        }
        sidebarStyle = cn(widthStyle, hasLevel2Navigation ? sidebarMobileLevel2Style : sidebarMobileLevel1Style);
    }
    return /*#__PURE__*/ _jsx("main", {
        "data-testid": "Main",
        style: {
            marginLeft: sidebarWidth !== 0 ? sidebarWidth : undefined
        },
        className: cn(mainStyle, sidebarStyle, className),
        children: children
    });
}
const mainStyle = 'flex flex-col grow mobile:grow-0 mobile:overflow-x-hidden mobile:ml-0 mt-[--headerHeight] mobile:mt-0';
const sidebarLevel1Style = 'ml-[--sidebarWidth]';
const sidebarLevel2Style = 'ml-[--sidebarLevel2Width]';
const sidebarCollapsedStyle = 'ml-[--sidebarCollapsedWidth]';
const sidebarMobileLevel1Style = 'mobile:mb-[--mobileSidebarHeight]';
const sidebarMobileLevel2Style = 'mobile:mb-[--mobileSidebarLevel2Height]';
